const PromotionTypes = {
    ADD_PROMOTION: "ADD_PROMOTION",
    EDIT_PROMOTION: "EDIT_PROMOTION"
};

export { PromotionTypes };